const VIDEO_TYPES = {
    YOUTUBE: 1,
    FLASH: 2,
    EMBEDDED_FLASH: 3,
};

export default VIDEO_TYPES;
